import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import { OrbitFieldSelect } from '../components/orbitFieldSelect';
import AutocompleteField from '../../../components/general/fields/autocompleteField';
import { ORBIT_ADDRESS_QUADRANT_OPTIONS } from './quadrantOptions';
import { OrbitFullAddressField } from './fullAddressField';
import { useOrbitAddress } from './hook';
import { OrbitAddressProps } from '../sectionProps';

export const OrbitAddressForm = (props: OrbitAddressProps) => {
    const { readOnly } = props;
    const { formik, cities, citiesError, types1, types1Error, letters } =
        useOrbitAddress(props);

    if (readOnly) {
        return (
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12}>
                    <FieldText
                        label="Dirección"
                        name="address"
                        size="small"
                        disabled
                        value={formik.values.address}
                    />
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12}>
                <AutocompleteField
                    data={cities}
                    label="Ciudad"
                    name="city"
                    size="small"
                    required
                    disabled={Boolean(citiesError) || cities.length === 0}
                    placeholder={
                        citiesError ? 'Catálogo no disponible' : undefined
                    }
                    onBlur={formik.handleBlur}
                    touched={formik.touched.city || Boolean(citiesError)}
                    errors={formik.errors.city || citiesError}
                    value={formik.values.city}
                    onChangeValue={(value: string) =>
                        formik.setFieldValue('city', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrbitFieldSelect
                    data={types1}
                    label="Tipo 1"
                    name="type1"
                    size="small"
                    required
                    disabled={Boolean(types1Error) || types1.length === 0}
                    emptyOptionLabel={
                        types1Error ? 'Catálogo no disponible' : undefined
                    }
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type1 || Boolean(types1Error)}
                    errors={formik.errors.type1 || types1Error}
                    value={
                        typeof formik.values.type1 === 'string'
                            ? formik.values.type1
                            : String(
                                  (formik.values.type1 as { id?: string })
                                      ?.id ||
                                      (
                                          formik.values.type1 as {
                                              name?: string;
                                          }
                                      )?.name ||
                                      ''
                              )
                    }
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FieldText
                    label="Tipo 2"
                    name="type2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type2}
                    errors={formik.errors.type2}
                    value={formik.values.type2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FieldText
                    label="Número"
                    name="number1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number1}
                    errors={formik.errors.number1}
                    value={formik.values.number1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter1"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter1}
                    errors={formik.errors.letter1}
                    value={formik.values.letter1}
                    onChangeValue={(value: string) =>
                        formik.setFieldValue('letter1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter2}
                    errors={formik.errors.letter2}
                    value={formik.values.letter2}
                    onChangeValue={(value: string) =>
                        formik.setFieldValue('letter2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrbitFieldSelect
                    data={ORBIT_ADDRESS_QUADRANT_OPTIONS}
                    label="Cuadr."
                    name="quadrant1"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant1}
                    errors={formik.errors.quadrant1}
                    value={formik.values.quadrant1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FieldText
                    label="Número"
                    name="number2"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number2}
                    errors={formik.errors.number2}
                    value={formik.values.number2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter3"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter3}
                    errors={formik.errors.letter3}
                    value={formik.values.letter3}
                    onChangeValue={(value: string) =>
                        formik.setFieldValue('letter3', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter4"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter4}
                    errors={formik.errors.letter4}
                    value={formik.values.letter4}
                    onChangeValue={(value: string) =>
                        formik.setFieldValue('letter4', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrbitFieldSelect
                    data={ORBIT_ADDRESS_QUADRANT_OPTIONS}
                    label="Cuadr."
                    name="quadrant2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant2}
                    errors={formik.errors.quadrant2}
                    value={formik.values.quadrant2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FieldText
                    label="Número"
                    name="number3"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number3}
                    errors={formik.errors.number3}
                    value={formik.values.number3}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <OrbitFieldSelect
                    data={ORBIT_ADDRESS_QUADRANT_OPTIONS}
                    label="Cuadr."
                    name="quadrant3"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant3}
                    errors={formik.errors.quadrant3}
                    value={formik.values.quadrant3}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Complemento"
                    name="complement"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.complement}
                    errors={formik.errors.complement}
                    value={formik.values.complement}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <OrbitFullAddressField
                    value={formik.values.address}
                    showError={
                        (Boolean(formik.touched.address) ||
                            formik.submitCount > 0) &&
                        Boolean(formik.errors.address)
                    }
                    errorMessage={formik.errors.address as string}
                />
            </Grid>
        </Grid>
    );
};
